import i18n from '@/i18n';
import { Handshake, Brain, Flame, type LucideIcon } from 'lucide-react';

export interface Maestro {
  id: string;
  /** Emoji — kept for compact/legacy contexts (e.g. select dropdowns). */
  icon: string;
  /** Lucide icon — the unified visual used across the app via <MaestroAvatar>. */
  Icon: LucideIcon;
  nameKey: string;
  titleKey: string;
  subtitleKey: string;
  descriptionKey: string;
  accentColor: string;
  accentColorLight: string;
  accentBg: string;
  accentBgHover: string;
  accentBorder: string;
}

/** Translated display getters */
export function getMaestroName(m: Maestro): string {
  return i18n.t(m.nameKey);
}
export function getMaestroTitle(m: Maestro): string {
  return i18n.t(m.titleKey);
}
export function getMaestroSubtitle(m: Maestro): string {
  return i18n.t(m.subtitleKey);
}
export function getMaestroDescription(m: Maestro): string {
  return i18n.t(m.descriptionKey);
}

/**
 * MVP: el maestro (personalidad del comprador) se asigna según la dificultad
 * elegida, para que el usuario afronte distintos perfiles en vez de siempre el
 * mismo. 1-2 → Closer (receptivo), 3-4 → Estratega (analítico), 5 → Provocador.
 */
export function maestroIdForDifficulty(difficulty: number): string {
  if (difficulty >= 5) return 'provocador';
  if (difficulty >= 3) return 'estratega';
  return 'cerrador';
}

export const maestros: Maestro[] = [
  {
    id: 'cerrador',
    icon: '🎯',
    Icon: Handshake,
    nameKey: 'maestros.cerrador_name',
    titleKey: 'maestros.cerrador_title',
    subtitleKey: 'maestros.cerrador_subtitle',
    descriptionKey: 'maestros.cerrador_description',
    accentColor: '#E8734A',
    accentColorLight: '#D4693E',
    accentBg: 'bg-[#E8734A]/10',
    accentBgHover: 'hover:bg-[#E8734A]/15',
    accentBorder: 'border-[#E8734A]/30',
  },
  {
    id: 'estratega',
    icon: '♟️',
    Icon: Brain,
    nameKey: 'maestros.estratega_name',
    titleKey: 'maestros.estratega_title',
    subtitleKey: 'maestros.estratega_subtitle',
    descriptionKey: 'maestros.estratega_description',
    accentColor: '#6674C9',
    accentColorLight: '#5B6BBF',
    accentBg: 'bg-[#6674C9]/10',
    accentBgHover: 'hover:bg-[#6674C9]/15',
    accentBorder: 'border-[#6674C9]/30',
  },
  {
    id: 'provocador',
    icon: '⚡',
    Icon: Flame,
    nameKey: 'maestros.provocador_name',
    titleKey: 'maestros.provocador_title',
    subtitleKey: 'maestros.provocador_subtitle',
    descriptionKey: 'maestros.provocador_description',
    accentColor: '#E63946',
    accentColorLight: '#DC3545',
    accentBg: 'bg-[#E63946]/10',
    accentBgHover: 'hover:bg-[#E63946]/15',
    accentBorder: 'border-[#E63946]/30',
  },
];
